export const templateSettings = JSON.parse(document.getElementById('template-settings-config').textContent);
